"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makePhrasesComponentPlaceholder = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const makePhrasesComponentPlaceholder = (i18nInstance, lng) => {
    const Phrases = (props) => ((0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { defaults: props.k, components: props.c, i18n: i18nInstance, values: { ...props.v, formatParams: props.formatParams }, tOptions: { lng } }));
    Phrases.displayName = 'Phrases.placeholder';
    return Phrases;
};
exports.makePhrasesComponentPlaceholder = makePhrasesComponentPlaceholder;
//# sourceMappingURL=makePhrasesComponentPlaceholder.js.map